module.exports = __webpack_public_path__ + "img/card-d2.4801c393.png";